import Tooltip from '@mui/material/Tooltip';


//OLD
// export default (item) => (

//     <Tooltip title={item?.tooltip??item?.label} placement="right">
//     <a className="flex align-items-center p-menuitem-link" style={{
//         // disable
//         pointerEvents: item?.disabled ? "none" : "auto",
//     }} title={item?.title} onClick={item.command}>
//         <span style={{ color: item?.disabled ? 'grey' : item?.iconColor ?? "black" }} className={item.icon + ' pr-1'} />
//         <span style={{ color: item?.disabled ? "grey" : item?.color ?? "black", ...item?.style }} className="mx-0">{item.label}</span>
//         {item.shortcut && <span style={{
//             color: "grey", fontWeight: "bold", fontSize: "0.8em", letterSpacing: "1px"
//         }} className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
//     </a>
//     </Tooltip>
// );

export default (item) => {
    const handleClick = (e) => {
        if (item.command) {
            item.command(e);
        }
        const openItems = document.querySelectorAll('.p-menuitem-active');
        openItems.forEach((el) => el.classList.remove('p-menuitem-active'));
    };

    return (
        <Tooltip title={item?.tooltip ?? item?.label} placement="right">
            <a
                className="flex align-items-center p-menuitem-link"
                style={{ pointerEvents: item?.disabled ? 'none' : 'auto' }}
                title={item?.title}
                onClick={handleClick}
            >
                <span
                    style={{ color: item?.disabled ? 'grey' : item?.iconColor ?? 'black' }}
                    className={item.icon + ' pr-1'}
                />
                <span
                    style={{ color: item?.disabled ? 'grey' : item?.color ?? 'black', ...item?.style }}
                    className="mx-0"
                >
                    {item.label}
                </span>
                {item.shortcut && (
                    <span
                        style={{
                            color: 'grey',
                            fontWeight: 'bold',
                            fontSize: '0.8em',
                            letterSpacing: '1px',
                        }}
                        className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
                    >
                        {item.shortcut}
                    </span>
                )}
            </a>
        </Tooltip>
    );
};
